  // export const backendUrl = "http://127.0.0.1:8000";
export const backendUrl = "https://sowgatlar.com.tm";
// 
export const limit = 12;
export const screen_limit = 900;